import { User } from '../types';

/**
 * ATENÇÃO: Este é um modelo de cálculo de impostos simplificado.
 * Os valores são apenas estimativas e não devem ser usados para fins
 * de declaração de impostos real. Consulte um contador para obter
 * valores precisos.
 */

// Tabela IRPF (Pessoa Física) - Exemplo simplificado
const irpfTable = [
  { min: 0, max: 2112, rate: 0, deduction: 0 },
  { min: 2112.01, max: 2826.65, rate: 0.075, deduction: 158.4 },
  { min: 2826.66, max: 3751.05, rate: 0.15, deduction: 370.4 },
  { min: 3751.06, max: 4664.68, rate: 0.225, deduction: 651.73 },
  { min: 4664.69, max: Infinity, rate: 0.275, deduction: 884.96 },
];

// Alíquota Simples Nacional (Pessoa Jurídica) - Anexo III (Serviços)
const simplesNacionalRate = 0.06; // 6% para faturamento anual de até R$180.000

/**
 * Calcula o imposto estimado com base no perfil do usuário e na receita.
 * @param revenue - A receita total do período.
 * @param user - O objeto do usuário, contendo entityType e profession.
 * @returns O valor estimado do imposto.
 */
export const calculateTaxes = (revenue: number, user: User): number => {
  if (!user.entityType) {
    return 0; // Se não houver tipo de entidade, não calcula
  }

  if (user.entityType === 'individual') {
    // Cálculo para Pessoa Física (IRPF)
    const tableRow = irpfTable.find(row => revenue >= row.min && revenue <= row.max);
    if (!tableRow) {
      return 0;
    }
    const grossTax = revenue * tableRow.rate;
    const tax = grossTax - tableRow.deduction;
    return tax > 0 ? tax : 0;

  } else if (user.entityType === 'company') {
    // Cálculo para Pessoa Jurídica (Simples Nacional - Serviços)
    // Assumindo Anexo III para serviços
    return revenue * simplesNacionalRate;
  }

  return 0;
};
